/**
 * @module cercaliagl/service/ReverseGeocoding
 */

import Service from './Service';

/**
 * @classdesc
 * <b>Javascript ES5</b>
 * ```js
 * const reverseGeocoding = new cercaliagl.service.ReverseGeocoding({ ... });
 * ```
 * Reverse geocoding service obtains an address given a position.
 *
 * Example usage:
 * ```js
 * const reverseGeocoding = new cercaliagl.service.ReverseGeocoding();
 * const position = new cercaliagl.LonLat(-3.696100270, 40.424812754);
 * reverseGeocoding.getDirection(position, (data) => {
 *   console.log(data.cercalia.proximity.gelist.ge);
 * });
 * ```
 *
 * @extends {Service}
 * @api
 */
class ReverseGeocoding extends Service {
  constructor() {
    super();
    /**
     * @private
     * @type {ProximityResult}
     */
    this.response_ = null;
  }

  /**
   * Gets the address from a coordinate cercalia.LonLat
   * @param {import('../LonLat').default} lonLat Position
   * @param {Function} callbackFn First and unique argument received is {@link import("../servers.js").ProximityResult ProximityResult}
   * @api
   */
  getDirection(lonLat, callbackFn) {
    const mo = `${lonLat.getLat()},${lonLat.getLon()}`;
    const params = { cmd: 'reversegeocoding', mo };
    this.getRequest({
      data: params,
      callbackFn: (data) => {
        this.response_ = data;
        if (callbackFn) {
          callbackFn(data);
        } else {
          console.warn('No callback function defined'); // eslint-disable-line no-console
        }
      },
    });
  }
}

export default ReverseGeocoding;
